<template>
  <footer class="py-4 bg-dark mt-auto" v-if="$store.getters.user.loggedIn">
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between small">
      <div class="text-muted">Copyright &copy; KPSS </div>
      <div>
        <a href="#" onclick="alert('Böyle bir şey yok')">Privacy Policy</a>
        &middot;
        <a href="#" onclick="alert('Böyle bir şey de yok')">Terms &amp; Conditions</a>
      </div>
    </div>
  </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>
